import commentApi from '../../api/commentApi'

const state = {
    comments: [],
    comment: {}
}

const getters = {}

const actions = {
    async getComments({ commit }, documentID) {
        return new Promise((resolve, reject) => {
            commentApi.all(documentID).then((response) => {
                if (response.status == 200) {
                    commit("SET_COMMENTS", response.data);
                    resolve(response);
                }
                reject(response);
            }).catch((error) => {
                reject(error);
            })
        })
    },

    async saveComment({ commit }, comment) {
        const response = await commentApi.store(comment)
            .catch(err => {
                console.log(err)
                return false
            })

        if (response.status === 201) {
            console.log('COMMENT', response.data[0]);
            commit('SAVE_COMMENT', response.data[0])
            return true
        }
    },

    async getCommentById({ commit }, commentID) {
        const res = await commentApi.show(commentID)
            .catch(err => {
                console.log(err)
                return false
            })

        if (res.status === 200) {
            commit('GET_COMMENT', res.data)
            return true
        }
    },

    async updateComment({ commit }, comment) {
        const res = await commentApi.update(comment)
            .catch(err => {
                console.log(err)
                return false
            })

        if (res.status === 201) {
            commit('UPDATE_COMMENT', res.data)
            return true
        }
    },

    async deleteComment({ commit }, commentID) {
        const res = await commentApi.delete(commentID)
            .catch(err => {
                console.log(err);
                return false;
            });

        if (res.status === 200) {
            commit('DELETE_COMMENT', commentID);
            return true;
        }
    }
}

const mutations = {
    SET_COMMENTS: (state, comment) => state.comments = comment,

    GET_COMMENT: (state, comment) => state.comment = comment,

    SAVE_COMMENT: (state, comment) =>{ 
        state.comments.unshift(comment)},

    UPDATE_COMMENT: (state, comment) => {
        const index = state.comments.findIndex(comment => comment.id === comment.id);

        if (index !== -1) {
            state.comments.splice(index, 1, comment);
        }
    },

    DELETE_COMMENT: (state, commentID) => {
        state.comments = state.comments.filter(comment => comment.id === commentID);
    },
}

export default { state, actions, getters, mutations }